export class User {
  login : string;
  password: string;
  authToken: string;
  mandatorID: string;
  appID: string;  //variantID
  managedAppID: string; //targetVariantID
  autoAuthorize: boolean;
  cosyToken: string; 
}